/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerTierEnum;

(function (BrokerTierEnum) {
  BrokerTierEnum["TIER_1"] = "tier_1";
  BrokerTierEnum["TIER_2"] = "tier_2";
  BrokerTierEnum["TIER_3"] = "tier_3";
  BrokerTierEnum["TIER_4"] = "tier_4";
})(BrokerTierEnum || (BrokerTierEnum = {}));